import { useQuery } from 'react-query';

import { PowerlistHeaderData, fetchPowerlistHeaderData } from '../utils/backend-api/powerlist';

export const POWERLIST_HEADER_KEY = 'POWERLIST_HEADER';

export default function usePowerlistHeader(powerlistType: 'crypto' | 'enterprise') {
  const { data: powerlistHeader, isLoading: isLoadingHeader } = useQuery<PowerlistHeaderData>(
    POWERLIST_HEADER_KEY,
    async () => await fetchPowerlistHeaderData(powerlistType)
  );

  return { powerlistHeader, isLoadingHeader };
}
